import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sha256 } from 'js-sha256';
import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
const LoginTracking = ({ merchant_id, email, children }) => {
    const hashedEmail = sha256(email.toLowerCase());
    return (_jsxs(ReactHelmet, { children: [_jsx("script", { children: `
            window.dataLayer.push({
              "event": "login",
              "hashed_email": "${hashedEmail}",
              "merchant_id": "${merchant_id}"
            });
          ` }), children] }));
};
export default LoginTracking;
